import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CUSTOMERENVIRONMENT } from '@app/common/app-tokens';
import { Constants } from '@app/common/constants';
import { HttpHelper } from '@app/common/http-helper';
import { Environment } from '@environments/interface.environment';
import { concat, of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { CacheService } from './cache.service';
import { SphomeService } from './sphome.service';
import { UrlHelperService } from './url-helper.service';

@Injectable({
  providedIn: 'root'
})
export class MyLatestSitesService {

  public useCache = true;
  private readonly cacheKeyPrefix = 'MyLatestSitesService';

  constructor(private http: HttpClient,
              private cache: CacheService,
              private spHomeService: SphomeService,
              private httpHelper: HttpHelper,
              private urlHelperService: UrlHelperService,
              @Inject(CUSTOMERENVIRONMENT) private environment: Environment, ) { }

  getMyRecentSitesFromSpHome(start: number = 0, count: number = 10) {
    const cacheKey = `${this.cacheKeyPrefix}-${'getMyRecentSitesFromSpHome'}-${start.toString()}-${count.toString()}`;

    const fetchOperation = this.spHomeService.getSPHomeContext()
      .pipe(
        mergeMap(ctx => {
          const httpHeaders = new HttpHeaders().append('SPHome-ApiContext', ctx.Payload);
          return this.http.get<any>(`${ctx.Urls[0]}/api/v1/sites/recent?start=${start}&count=${count}`, {
            headers: httpHeaders
          });
        }),
        tap(data => {
          this.useCache && this.cache.set(cacheKey, data);
        }),
        catchError(this.httpHelper.handleError({ operation: 'getMyRecentSitesFromSpHome', result: {}, rethrow: true })));

    if (this.useCache) {
      const cachedData = this.cache.get<any>(cacheKey);
      if (cachedData) {
        return concat(of(cachedData), fetchOperation);
      }
    }

    return fetchOperation;
  }

  getMyRecentSitesFromGraph(start: number = 0, count: number = 10) {

    const httpParamsMyRecentSites = new HttpParams()
      .append('$top', count.toString())
      .append('$orderby', 'lastUsed/lastAccessedDateTime desc')
      .append('$filter', 'resourceVisualization/type eq \'Web\'');

    const cacheKey = `${this.cacheKeyPrefix}-${'getMyRecentSitesFromGraph'}-${start.toString()}-${count.toString()}`;
    const fetchOperation = this.http.get<any>(`${Constants.GRAPH_API_ENDPOINT + Constants.GRAPH_API_VERSION_ONE}/me/insights/used`,
    { params: httpParamsMyRecentSites })
    .pipe(
      map(response => {
        console.log(`fetched result: my recent sites: `, response);
        return response.value ;
      }),
      tap(data => {
        this.useCache && this.cache.set(cacheKey, data);
      }),
      catchError(this.httpHelper.handleError({ operation: 'getMyRecentSitesFromGraph', result: new Array<any>(), cacheKey: cacheKey })));

    if (this.useCache) {
    const cachedData = this.cache.get<Array<any>>(cacheKey);
    if (cachedData) {
      return concat(of(cachedData), fetchOperation);
    }
  }
    return fetchOperation;
 }

  getMyRecentSitesFromSP(start: number = 0, count: number = 10) {

    const cacheKey = `${this.cacheKeyPrefix}-${'getMyRecentSitesFromSp'}-${start.toString()}-${count.toString()}`;
    const hostName = this.urlHelperService.getHostName(this.environment.coreWorkplaceSiteUrl);
    const httpParamsMyRecentSites = new HttpParams()
    .append('$top', count.toString());

    const fetchOperation = this.http
    .get<any>(`https://${hostName}/_api/v2.1/insights/recentSites`, { params: httpParamsMyRecentSites })
    .pipe(
      map(response => {
        console.log(`fetched result: my recent sites: `, response);
        return response ;
      }),
      tap(data => {
        this.useCache && this.cache.set(cacheKey, data);
      }),
      catchError(this.httpHelper.handleError({ operation: 'getMyRecentSitesFromSP', result: new Array<any>(), cacheKey: cacheKey })));

    if (this.useCache) {
      const cachedData = this.cache.get<Array<any>>(cacheKey);
      if (cachedData) {
        return concat(of(cachedData), fetchOperation);
      }
    }
    return fetchOperation;
  }
}
